"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.track = void 0;
var utils_1 = require("./utils");
var navigator_1 = require("./navigator");
var env_1 = require("./env");
var browser_1 = require("./browser");
var IS_TRACKING = '__isTrackingPageViews__';
var ENDPOINT = 'p';
var SOURCE = 19;
var EVID = 3;
function shouldTrack(force) {
    return (force ||
        (!(0, env_1.isWebWorker)() &&
            (0, env_1.isBackoffice)() &&
            (0, env_1.getWindowIfTop)(function (window) { return !window[IS_TRACKING]; })));
}
function setIsTracking() {
    return (0, env_1.getWindowIfTop)(function (window) { return (window[IS_TRACKING] = true); });
}
function getLogger(loggerFactory) {
    return loggerFactory({ endpoint: ENDPOINT })
        .updateDefaults({ src: SOURCE, evid: EVID, vsi: (0, utils_1.guid)() })
        .logger();
}
function trackBrowsingSession(loggerFactory) {
    var logger = getLogger(loggerFactory);
    var firstInSession = 1;
    (0, navigator_1.listen)(function (fromUrl, toUrl) {
        var _a = (0, env_1.getWindowIfTop)(function (window) { return ({
            sr: (0, browser_1.getDesktopSize)(window),
            wr: (0, browser_1.getWindowSize)(window),
        }); }), sr = _a.sr, wr = _a.wr;
        logger.log({ from: fromUrl, to: toUrl, fis: firstInSession, sr: sr, wr: wr });
        firstInSession = 0;
    });
}
/**
 * Sends a page view event on initial load and on every page switch
 * BI event definition: http://bo.wix.com/bi-catalog-webapp/#/sources/19/events/3
 */
function track(loggerFactory, options) {
    if (options === void 0) { options = { force: false }; }
    if (shouldTrack(options.force)) {
        setIsTracking();
        trackBrowsingSession(loggerFactory);
    }
}
exports.track = track;
//# sourceMappingURL=tracker.js.map